export const WHO_WE_SERVE_CONTENT = {
  title: 'Who We Serve',
  description:
    'Adults and teens (with guardian consent) seeking focused, skills-based change—on its own or alongside existing care from qualified professionals.',
  buttonText: 'Ready To Begin?',
};
